import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Log trim-on-undefined errors with full stack so we can see original file:line (with source maps)
window.addEventListener('error', (event) => {
  if (
    event.message?.includes("reading 'trim'") ||
    (event.error?.message?.includes && event.error.message.includes("reading 'trim'"))
  ) {
    console.error(
      '[trim error] Full stack (check source map or devtools to see original file:line):',
      event.error?.stack ?? event.message
    )
  }
})

createRoot(document.getElementById("root")!).render(<App />);
